<template>
  <div class="page">
    <div class="right-box title">
      <el-form class="el-forminpt">
        <el-form-item label="时间" label-width="60px">
          <el-date-picker v-model="created_at" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="商品" label-width="60px">
          <el-input placeholder="请输入商品ID/名称" v-model="query.keyword">
          </el-input>
        </el-form-item>

        <div style="margin-left: 20px">
          <el-button style="background-color: #229fa0; color: #f6f7fb" @click="selectChanged()">搜索</el-button>
          <el-button style="background-color: #229fa0; color: #f6f7fb" @click="selectChanged2()">重置</el-button>
          <el-button style="background-color: #229fa0; color: #f6f7fb" @click="addbox()">商品录入</el-button>
          <el-button style="background-color: #229fa0; color: #f6f7fb" @click="ute()">导出</el-button>
        </div>
      </el-form>
    </div>
    <div class="talet-tabs-one">
      <div class="talet-tabs-left">
        <el-table @select-all="selectAll" @select="checkSelect" :data="tableData" style="width: 100%"
          :default-sort="{ prop: 'date', order: 'descending' }">
          <el-table-column label="序号" type="selection" show-overflow-tooltip width="50">
          </el-table-column>
          <el-table-column prop="platform" label="产品主图">
            <template slot-scope="scope">
              <div @click="change(scope.row)">
                <el-image :src="scope.row.banner" style="width: 120px; height: 120px"></el-image>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="title" label="产品标题" width="280">
            <template slot-scope="scope">
              <div class="box-logo">
                <img src="../../assets/images/douyin.png" style="width: 20px; height: 20px" alt="" srcset="" />
                <span style="font-weight: 600">{{ scope.row.title }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="产品店铺" width="250">
            <template slot-scope="scope">
              <div>
                <div style="
                    font-weight: 600;
                    margin-left: 10px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                  ">
                  {{ scope.row.shop_name }}
                </div>
                <div style="margin-top: 10px" class="table">
                  <div>
                    <span style="font-weight: 600; margin-left: 10px">
                      商品评分:</span>
                    <el-tag style="font-weight: 600; color: red" v-if="scope.row.shop_creadit_product" type="success">
                      {{ scope.row.shop_creadit_product | formatting }}
                    </el-tag>
                  </div>
                  <div>
                    <span style="font-weight: 600; margin-left: 10px">
                      商家服务:</span>
                    <el-tag style="font-weight: 600; color: green" v-if="scope.row.shop_creadit_service" type="info">
                      {{ scope.row.shop_creadit_service | formatting }}
                    </el-tag>
                  </div>
                  <div>
                    <span style="font-weight: 600; margin-left: 10px">物流体验:</span>
                    <el-tag style="font-weight: 600; color: blue" v-if="scope.row.shop_creadit_logistics"
                      type="warning">{{
                        scope.row.shop_creadit_logistics | formatting
                      }}</el-tag>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="commission" label="佣金比例">
            <template slot-scope="scope">
              <span style="font-weight: 600; margin-left: 10px">{{ scope.row.commission }}%</span>
            </template>
          </el-table-column>
          <el-table-column prop="need_fans_number" label="橱窗销量要求">
            <template slot-scope="scope">
              <span style="font-weight: 600; margin-left: 10px">
                ≥ {{ scope.row.need_fans_number }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="直播价格">
            <template slot-scope="scope">
              <span style="font-weight: 600; margin-left: 10px">
                ¥ {{ scope.row.sku | capitalize }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="channels_name" label="所属团长">
            <template slot-scope="scope">
              <span style="font-weight: 600; margin-left: 10px">{{
                scope.row.channels_name
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="updated_at" label="更新时间" width="200"></el-table-column>
          <el-table-column prop="address" key="10" label="操作" width="260px">
            <template slot-scope="scope">
              <el-button type="primary" size="small" @click="openbox(scope.row)">领样</el-button>
              <el-button style="background-color: #229fa0; border: none; color: #f6f7fb" size="small"
                @click="change2(scope.row)">修改</el-button>
              <el-button type="danger" size="small" @click="del(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="block">
      <el-pagination background @size-change="sizeChangeHandle" layout="total,sizes, prev, pager, next, jumper"
        @current-change="handleCurrentChange" :total="total"></el-pagination>
    </div>
    <!-- 录入页面 -->
    <el-dialog title="添加录入" :visible.sync="dialogVisible" width="50%" :close-on-click-modal="false" @close="close">
      <el-form ref="form" :rules="rules" :model="form" label-width="120px" style="width: 100%" class="title-box">
        <el-form-item label="商品链接" prop="url">
          <el-input placeholder="请输入内容" v-model.trim="form.url" style="width: 80%">
            <el-button slot="append" style="background-color: #229fa0; border: none; color: #f6f7fb" @click="analysis">
              商品解析</el-button>
            <el-button slot="append" style="
                background-color: #229fa0;
                border: none;
                color: #f6f7fb;
                margin-left: 10px;
              " @click="openDataCatch">
              数据抓取</el-button>
          </el-input>
        </el-form-item>
      </el-form>
      <div class="omp-box">
        <div class="omp-box-left">
          <el-image style="width: 200px; height: 200px" :src="form.banner"></el-image>
        </div>
        <div class="omp-box-right">
          <el-row>
            <el-col :span="6"><span> 商家体验</span><span style="color: #3aced0">
                {{ form.shop_creadit_service }}
              </span>

              分
            </el-col>
            <el-col :span="6"><span> 商家服务</span>
              <span style="color: #bbdd24">
                {{ form.shop_creadit_product }} </span>分
            </el-col>
            <el-col :span="6"><span> 物流体验</span><span style="color: #dd2b13">
                {{ form.shop_creadit_logistics }}
              </span>
              分
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5"> <span> 商品标题 </span> </el-col>
            <el-col :span="15">
              <el-input v-model="form.title"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5"> <span> 商品ID </span></el-col>
            <el-col :span="15">
              <el-input v-model="form.platform_product_id"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5"> <span> 发货时间</span> </el-col>
            <el-col :span="15">
              <el-input v-model="form.post_time"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5"> <span> 商家电话 </span> </el-col>
            <el-col :span="15">
              <el-input v-model="form.shop_tel"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5"> <span> 发货地址 </span></el-col>
            <el-col :span="15">
              <el-input v-model="form.post_place"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5"> <span> 不发货地区 </span></el-col>

            <el-col :span="15">
              <el-input v-model="form.no_post_area" type="textarea"></el-input>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="xiahua"></div>
      <div class="buttom-box">
        <div class="voeo-box2">
          <div class="tanble">
            <el-table :data="form.sku" height="240" border>
              <el-table-column prop="name" label="规格名称"> </el-table-column>
              <el-table-column prop="price" label="原价">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.price" style="width: 100%; hight: 100%" ng-model="schedule.round"
                    placeholder="请输入数字">
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="current_price" label="直播价">
                <template slot-scope="scope">
                  <el-input ng-model="schedule.round" placeholder="请输入数字" v-model="scope.row.current_price"
                    style="width: 100%; hight: 100%">
                  </el-input>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div>
            <el-form ref="form2" :rules="rules2" :model="form" label-width="80px" style="width: 82%" class="right-box2">
              <el-form-item label="产品分类" prop="categories_id">
                <el-select style="width: 100%" v-model="form.categories_id" @click="product()" placeholder="请选择">
                  <el-option v-for="(item, index) in option" :key="index" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="带货方式" prop="sellway">
                <el-select style="width: 100%" v-model="form.sellway" placeholder="请选择">
                  <el-option label="直播 " value="1"> </el-option>
                  <el-option label="短视频" value="2"></el-option>
                  <el-option label="所有" value="9"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="销量要求" style="width: 100%" prop="need_fans_number">
                <el-input v-model.number="form.need_fans_number" onkeyup="value=value.replace(/[^\d]/g,'')"
                  onblur="value=value.replace(/[^\d]/g,'')" ng-model="schedule.round" placeholder="请输入数字"></el-input>
              </el-form-item>
              <el-form-item label="佣金比例" prop="commission">
                <el-input maxlength="2" onkeyup="value=value.replace(/[^\d]/g,'')"
                  onblur="value=value.replace(/[^\d]/g,'')" ng-model="schedule.round" placeholder="请输入数字"
                  v-model.number="form.commission"><i slot="suffix" style="font-style: normal; margin-right: 10px">%</i>
                </el-input>
              </el-form-item>
              <el-form-item label="服务费率" prop="service_charge">
                <el-input v-model.number="form.service_charge" onkeyup="value=value.replace(/[^\d]/g,'')"
                  onblur="value=value.replace(/[^\d]/g,'')" ng-model="schedule.round" placeholder="请输入数字"><i
                    slot="suffix" style="font-style: normal; margin-right: 10px">%</i></el-input>
              </el-form-item>
              <el-form-item label="产品销量" prop="sales">
                <el-input v-model.number="form.sales" onkeyup="value=value.replace(/[^\d]/g,'')"
                  onblur="value=value.replace(/[^\d]/g,'')" ng-model="schedule.round" placeholder="请输入数字"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>

        <div class="voeo-box">
          <el-form style="width: 100%" :rules="rules2" :model="form" label-width="120px">
            <el-row>
              <el-col :span="12">
                <el-form-item label="活动开始时间" prop="begin_time">
                  <el-date-picker style="width: 100%" v-model="form.begin_time" type="date" placeholder="选择日期"
                    :picker-options="pickerOptionsStart">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="活动结束时间" prop="end_time">
                  <el-date-picker style="width: 100%" v-model="form.end_time" type="date" placeholder="选择日期"
                    :picker-options="pickerOptionsEnd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="快递支持">
                  <el-input v-model="form.express" type="textarea" :rows="2"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="直播卖点文案">
                  <el-input v-model="form.copy_writer" type="textarea" :rows="2"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" style="background-color: #229fa0; border: none; color: #f6f7fb"
            @click="dialogVisible = false">取 消</el-button>
          <el-button size="small" style="background-color: #229fa0; border: none; color: #f6f7fb" type="primary"
            @click="addtempone()">确 定</el-button>
        </span>
      </div>
    </el-dialog>
    <!-- 修改界面 -->
    <el-dialog title="修改录入" :visible.sync="dialogVisible2" width="50%" :close-on-click-modal="false">
      <el-form ref="form" :rules="rules" :model="upadate" label-width="120px" style="width: 100%" class="title-box">
        <el-form-item label="商品链接" prop="url">
          <el-input placeholder="请输入内容" v-model="upadate.url" style="width: 80%">
            <el-button slot="append" style="background-color: #229fa0; border: none; color: #f6f7fb" @click="analysis">
              商品解析</el-button>
          </el-input>
        </el-form-item>
      </el-form>
      <div class="omp-box">
        <div class="omp-box-left">
          <el-image style="width: 200px; height: 200px" :src="upadate.banner"></el-image>
        </div>
        <div class="omp-box-right">
          <el-row>
            <el-col :span="6"><span> 商家体验</span><span style="color: #3aced0">
                {{ upadate.shop_creadit_service | formatting }}
              </span>

              分
            </el-col>
            <el-col :span="6"><span> 商家服务</span>
              <span style="color: #bbdd24">
                {{ upadate.shop_creadit_product | formatting }} </span>分
            </el-col>
            <el-col :span="6"><span> 物流体验</span><span style="color: #dd2b13">
                {{ upadate.shop_creadit_logistics | formatting }}
              </span>
              分
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5"> <span> 商品标题 </span> </el-col>
            <el-col :span="15">
              <el-input v-model="upadate.title"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5"> <span> 商品ID </span></el-col>
            <el-col :span="15">
              <el-input v-model="upadate.platform_product_id"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5"> <span> 发货时间</span> </el-col>

            <el-col :span="15">
              <el-input v-model="upadate.post_time"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5"> <span> 商家电话 </span> </el-col>
            <el-col :span="15">
              <el-input v-model="upadate.shop_tel"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5"> <span> 发货地址 </span></el-col>
            <el-col :span="15">
              <el-input v-model="upadate.post_place"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5"> <span> 不发货地区 </span></el-col>
            <el-col :span="15">
              <el-input v-model="upadate.no_post_area" type="textarea" :rows="2"></el-input>
            </el-col>
          </el-row>
          <!-- <el-row>
            <el-col :span="5"> <span>产品销量</span></el-col>
            <el-col :span="15">
              <el-input
                v-model="upadate.sales"
                type="textarea"
                :rows="2"
              ></el-input>
            </el-col>
          </el-row> -->
        </div>
      </div>
      <div class="xiahua"></div>
      <div class="buttom-box">
        <div class="voeo-box2">
          <div class="tanble">
            <el-table :data="upadate.sku" height="240" border>
              <el-table-column prop="name" label="规格名称" width="160">
              </el-table-column>
              <el-table-column prop="price" label="原价" width="110">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.price" style="width: 100%; hight: 100%" placeholder="请输入数字">
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="current_price" width="110" label="直播价">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.current_price" style="width: 100%; hight: 100%">
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="操作">
                <template slot-scope="scope">
                  <span style="
                      background-color: #229fa0;
                      border: none;
                      color: #f6f9fb;
                    " size="small" @click="Skuupdateone(scope.row)">修改</span>
                  <span style="
                      background-color: #229fa0;
                      border: none;
                      color: #f6f7fb;
                      margin-left: 10px;
                    " type="danger" size="small" @click="SkudelOne(scope.row.id)">删除</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div>
            <el-form ref="form2" :rules="rules2" :model="upadate" label-width="80px" style="width: 82%"
              class="right-box2">
              <el-form-item label="产品分类" prop="categories_id">
                <el-select style="width: 100%" v-model="upadate.categories_id" placeholder="请选择">
                  <el-option v-for="(item, index) in option" :key="index" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="带货方式" prop="sellway">
                <el-select style="width: 100%" v-model="upadate.sellway" placeholder="请选择">
                  <el-option label="直播 " value="1"> </el-option>
                  <el-option label="短视频" value="2"></el-option>
                  <el-option label="所有" value="9"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="销量要求" style="width: 100%" prop="need_fans_number">
                <el-input v-model.number="upadate.need_fans_number" onkeyup="value=value.replace(/[^\d]/g,'')"
                  onblur="value=value.replace(/[^\d]/g,'')" ng-model="schedule.round" placeholder="请输入数字"></el-input>
              </el-form-item>
              <el-form-item label="佣金比例" prop="commission">
                <el-input maxlength="2" v-model.number="upadate.commission" onkeyup="value=value.replace(/[^\d]/g,'')"
                  onblur="value=value.replace(/[^\d]/g,'')" ng-model="schedule.round" placeholder="请输入数字"><i
                    slot="suffix" style="font-style: normal; margin-right: 10px">%</i></el-input>
              </el-form-item>
              <el-form-item label="服务费率" prop="service_charge">
                <el-input v-model.number="upadate.service_charge" onkeyup="value=value.replace(/[^\d]/g,'')"
                  onblur="value=value.replace(/[^\d]/g,'')" ng-model="schedule.round" placeholder="请输入数字"><i
                    slot="suffix" style="font-style: normal; margin-right: 10px">%</i></el-input>
              </el-form-item>
              <el-form-item label="产品销量" prop="sales">
                <el-input v-model.number="upadate.sales" onkeyup="value=value.replace(/[^\d]/g,'')"
                  onblur="value=value.replace(/[^\d]/g,'')" ng-model="schedule.round" placeholder="请输入数字"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>

        <div class="voeo-box">
          <el-form ref="form2" style="width: 100%" :rules="rules2" :model="upadate" label-width="120px">
            <el-row>
              <el-col :span="12">
                <el-form-item label="活动开始时间" prop="begin_time">
                  <el-date-picker style="width: 100%" v-model="upadate.begin_time" type="date" placeholder="选择日期"
                    :picker-options="pickerOptionsStart2">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="活动结束时间" prop="end_time">
                  <el-date-picker style="width: 100%" v-model="upadate.end_time" type="date" placeholder="选择日期"
                    :picker-options="pickerOptionsEnd2">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="快递支持">
                  <el-input v-model="upadate.express" type="textarea" :rows="2"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="直播卖点文案">
                  <el-input v-model="upadate.copy_writer" type="textarea" :rows="2"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" style="background-color: #229fa0; border: none; color: #f6f7fb"
            @click="dialogVisible2 = false">取 消</el-button>
          <el-button size="small" style="background-color: #229fa0; border: none; color: #f6f7fb" type="primary"
            @click="Updatetempone()">确 定</el-button>
        </span>
      </div>
    </el-dialog>
    <!-- 详情页面 -->
    <el-dialog title="商品详情" :visible.sync="dialogVisible1" width="65%" :close-on-click-modal="false">
      <div class="box">
        <el-row>
          <el-col :span="10">
            <div class="lunbo">
              <el-carousel indicator-position="outside">
                <el-carousel-item v-for="item in upadate.img_list" :key="item">
                  <img :src="item" alt="" srcset="" />
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="box-text">
              <div class="box-logo">
                <span>店铺LOGO：</span>
                <img :src="upadate.shop_logo" alt="" srcset="" />
              </div>
              <div>店铺名称：{{ upadate.shop_name }}</div>
              <!-- <div>店铺销量 {{ 10 }}件</div> -->
              <div>商品体验：{{ upadate.shop_creadit_product }} 分</div>
              <div>商家服务：{{ upadate.shop_creadit_service }} 分</div>
              <div>物流体验：{{ upadate.shop_creadit_logistics }} 分</div>
            </div>
            <div class="btn">
              <el-button size="mini" type="success" v-clipboard:copy="upadate.url" v-clipboard:success="onCopy"
                v-clipboard:error="onError">复制团长链接</el-button>
              <el-button size="mini" type="primary" v-clipboard:copy="list_zhibo" v-clipboard:success="onCopy2">
                复制推品文案文案</el-button>
              <el-button size="mini" type="warning" @click="openxiangqing">查看详情介绍</el-button>
            </div>
            <el-table :data="upadate.sku" style="width: 100%">
              <el-table-column prop="name" width="320" label="规格">
              </el-table-column>
              <el-table-column prop="price" label="原价"> </el-table-column>
              <el-table-column prop="current_price" label="现价">
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="12">
            <div class="box-right" style="margin-left: 60px">
              <div class="box-logo">
                <img src="../../assets/images/douyin.png" alt="" srcset="" />
                <span style="font-size: 20px; font-wight: bold">{{
                  upadate.title
                }}</span>
              </div>

              <el-row>
                <el-col :span="8"><span>产品ID</span></el-col>
                <el-col :span="16">{{ upadate.platform_product_id }}</el-col>
              </el-row>
              <el-row>
                <el-col :span="8"><span>产品分类</span></el-col>
                <el-col :span="16">{{
                  upadate.categories_id | secletproduct
                }}</el-col>
              </el-row>

              <el-row>
                <el-col :span="8"><span>所属团长</span></el-col>
                <el-col :span="16">{{ upadate.channels_name }}</el-col>
              </el-row>

              <el-row>
                <el-col :span="8"><span>佣金比例</span></el-col>
                <el-col :span="16">{{ upadate.commission }} %</el-col>
              </el-row>

              <el-row>
                <el-col :span="8"><span>实际销量</span></el-col>
                <el-col :span="16">{{ upadate.sales }}</el-col>
              </el-row>
              <el-row>
                <el-col :span="8"><span>活动时间</span></el-col>
                <el-col :span="16">{{ upadate.begin_time }}</el-col>
              </el-row>

              <el-row>
                <el-col :span="8"><span>发货地点</span></el-col>
                <el-col :span="16">{{ upadate.post_place }}</el-col>
              </el-row>

              <el-row>
                <el-col :span="8"><span>发货时间</span></el-col>
                <el-col :span="16">{{ upadate.post_time }}</el-col>
              </el-row>

              <el-row>
                <el-col :span="8"><span>发货快递支持</span></el-col>
                <el-col :span="16">{{ upadate.express }}</el-col>
              </el-row>

              <el-row>
                <el-col :span="8"><span>不发货地区</span></el-col>
                <el-col :span="16">{{ this.upadate.no_post_area }}</el-col>
              </el-row>

              <el-row>
                <el-col :span="8"><span>橱窗销量要求</span></el-col>
                <el-col :span="16">{{ this.upadate.need_fans_number }}</el-col>
              </el-row>
              <el-row>
                <el-col :span="8"><span>创建时间</span></el-col>
                <el-col :span="16">{{ upadate.begin_time }}</el-col>
              </el-row>

              <el-row>
                <el-col :span="8"><span>最后修改时间</span></el-col>
                <el-col :span="16">{{ upadate.end_time }}</el-col>
              </el-row>
              <el-row>
                <el-col :span="8"><span>直播卖点文案</span></el-col>
                <el-col :span="16">{{ upadate.copy_writer }}</el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <el-dialog title="商品详情介绍" :visible.sync="dialogVisible3" width="21%" :close-on-click-modal="false">
      <div class="img_list">
        <div v-for="(item, index) in upadate.img_list" :key="index">
          <img :src="item" style="width: 380px" alt="" srcset="" />
        </div>
      </div>
    </el-dialog>
    <el-dialog @close="close2" title="数据粘贴框" :visible.sync="dialogVisible4" width="21%" :close-on-click-modal="false">
      <textarea rows="10" cols="54" v-model="dataJson"></textarea>
      <el-button style="background-color: #229fa0; color: #f6f7fb" @click="getJsonString">提交</el-button>
    </el-dialog>
    <!-- 领样 -->
    <intelligent ref="chird" v-bind:listproduct="listproduct"></intelligent>
  </div>
</template>

<style lang="less" scoped>
  .input-box {
    position: relative;
    left: -120px;
  }

  .right-box2 {
    position: relative;
    left: 50px;
  }

  .title {
    height: 60px !important;
    line-height: 60px;
  }

  /deep/ .el-dialog__body {
    padding: 0 0 0 0px;
  }

  /deep/ .el-table__header {
    height: 20px !important;
    background-color: rosybrown;
  }

  /deep/ .el-dialog__header {
    background-color: #3aced0;
  }

  .one {
    background-color: rgb(109, 105, 105);
    width: 100%;
    height: 20px;
  }

  .title-box {
    font-size: 20px !important;
    margin: 0 auto;
    width: 70% !important;

    .el-form-item__label {
      font-size: 50px;
    }
  }

  .dialog-footer {
    display: flex;
    margin-right: 80px;
    justify-content: flex-end;
  }

  .voeo-box {
    margin: 10px 80px;
  }

  .voeo-box2 {
    display: flex;
    margin: 10px 80px;

    .tanble {
      flex: 2;
      width: 100%;

      .el-table {
        width: 500px !important;
        position: relative;
        top: 10px;
        left: 20px;
        z-index: 99;
      }
    }

    .right-box {
      position: relative;
      left: 30px;
      // margin-left: 70px;
    }
  }

  .buttom-box {
    padding: 10px 0;
    background-color: rgb(255, 255, 255);
  }

  .el-form-item {
    margin: 10px 0px;
  }

  .right-left {
    margin-left: 5px;

    .el-row {
      color: #000;
      width: 100%;
      margin: 5px 0;
      width: 100%;

      .el-form-item {
        margin: 5px;
      }
    }
  }

  .table {
    div {
      margin: 10px;

      span {
        margin-left: 10px;
      }
    }
  }

  .btn {
    text-align: center;
    padding: 10px;

    .el-button {
      margin: 10px 0;

      width: 100% !important;
    }
  }

  .xiahua {
    margin-top: 25px;
    width: 100%;
    height: 1px;
    color: #7dcbca;
    border-top: 1px solid #7dcbca;
    padding: 5px 0;
  }

  .box-logo {
    img {
      vertical-align: middle;
      width: 20px;
      height: 20px;
    }
  }

  .box {
    height: 680px;
    // overflow: hidden;
    overflow-y: auto;
    margin: 10px 20px;
    padding: 20px 0px;

    .box-text {
      text-align: center;

      div {
        margin: 10px 0;
      }
    }
  }

  .omp-box {
    display: flex;
    margin: 0 80px;

    // padding: 10px;
    // width: 100%;
    // border-bottom: rosybrown 1px solid;
    .omp-box-left {
      flex: 1;
      position: relative;
      top: 30px;
    }

    .omp-box-right {
      flex: 2;
      margin-left: 60px;

      .el-col {
        margin: 5px 0;
      }

      span {
        font-weight: bold;
        // margin: 20px ;
        font-size: 16px;
        font-family: 'Helvetica Neue', Helvetica, 'PingFang SC',
          'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
      }
    }
  }

  .box-right {
    width: 100%;
    // height: 600px;
    margin: 0px 100px;

    .el-row {
      // height: 30px;
      padding: 8px;
      margin: 5px 0;
      border-bottom: 1px solid rgb(196, 196, 196);

      span {
        font-size: 16px;
        font-weight: bold;
      }
    }
  }

  .page {
    padding: 10px;
    background-color: #ffff;

    .block {
      display: flex;
      justify-content: flex-end;
      margin-top: 20px;
    }

    .right-box {
      height: 50px;

      //   border: 1px solid 1px;
      .el-forminpt {
        display: flex;
        margin-left: 10px;
      }

      position: relative;
      left: -30px;
    }
  }

  .img_list {
    text-align: center;
    height: 600px;
    overflow-y: auto;
  }

  /deep/ .el-carousel__container {
    width: 498px;
    height: 498px;
  }

  .lunbo {
    img {
      width: 498px;
      height: 498px;
      background-size: 100% 100%;
    }
  }
</style>
<script>
  import {
    Addtemp,
    Listtemp,
    Deltep,
    Updatetemp,
    Catetemp,
    Skudel,
    Exportexe,
    Skuupdate,
    Getinfo,
    Export
  } from '../../api/api2'
  import axios from 'axios'
  import table2excel from 'js-table2excel'
  import Intelligent from './intelligent.vue'
  export default {
    created() {
      this.getAll()
    },
    components: {
      Intelligent: Intelligent,
    },
    data() {
      var validatorFenshu = function(rule, value, callback) {
        if (value != '') {
          if (/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/.test(value) == false) {
            callback(new Error('请填写大于0的数字'))
          } else {
            callback()
          }
        } else {
          callback()
        }
      }
      return {
        //定义传入产品的list
        listproduct: [],
        arr: [],
        role: sessionStorage.getItem('role'),
        username: sessionStorage.getItem('username'),
        pickerOptionsStart: {
          disabledDate: (time) => {
            let endDateVal = this.form.end_time
            if (endDateVal) {
              return time.getTime() > new Date(endDateVal).getTime()
            }
          },
        },
        pickerOptionsEnd: {
          disabledDate: (time) => {
            let beginDateVal = this.form.begin_time
            if (beginDateVal) {
              return time.getTime() < new Date(beginDateVal).getTime()
            }
          },
        },
        pickerOptionsStart2: {
          disabledDate: (time) => {
            let endDateVal = this.upadate.end_time
            if (endDateVal) {
              return time.getTime() > new Date(endDateVal).getTime()
            }
          },
        },
        pickerOptionsEnd2: {
          disabledDate: (time) => {
            let beginDateVal = this.upadate.begin_time
            if (beginDateVal) {
              return time.getTime() < new Date(beginDateVal).getTime()
            }
          },
        },
        //复制直播文案
        list_zhibo: '',
        option: [],
        created_at: '',
        rules: {
          url: [{
            required: true,
            message: '请输入解析的内容',
            trigger: 'blur',
          }, ],
        },
        rules2: {
          need_fans_number: [{
            required: true,
            message: '请输入内容',
            trigger: 'blur',
          }, ],
          sellway: [{
            required: true,
            message: '请输入内容',
            trigger: 'blur',
          }, ],
          commission: [{
            required: true,
            message: '请输入内容',
            trigger: 'blur',
          }, ],
          service_charge: [{
            required: true,
            message: '请输入内容',
            trigger: 'blur',
          }, ],
          categories_id: [{
            required: true,
            message: '请输入内容',
            trigger: 'blur',
          }, ],
          begin_time: [{
            required: true,
            message: '请输入内容',
            trigger: 'blur',
          }, ],
          end_time: [{
            required: true,
            message: '请输入内容',
            trigger: 'blur',
          }, ],
        },
        form: {
          name: '',
        },
        dialogVisible: false,
        dialogVisible1: false,
        dialogVisible2: false,
        dialogVisible3: false,
        dialogVisible4: false,
        dataJson: '',
        form: {
          sales: '',
          url: '',
          platform: '',
          categories_id: '',
          banner: '',
          service_charge: '',
          img_list: '',
          platform_product_id: '',
          specimen_count: '',
          shop_creadit_product: '',
          shop_creadit_service: '',
          shop_creadit_logistics: '',
          product_format: '',
          shop_logo: '',
          shop_name: '',
          shop_tel: '',
          need_fans_number: '',
          copy_writer: '',
          post_place: '',
          post_time: '',
          begin_time: new Date(),
          end_time: new Date(),
          commission: '',
          sellway: '1',
          sku: [],
          title: '',
          service_charge: '',
          description: '',
          remark: '',
          gift_info: '',
          express: '',
        },
        upadate: {
          sales: '',
          service_charge: '',
          express: '',
          id: '',
          url: '',
          platform: '',
          categories_id: '',
          banner: '',
          img_list: '',
          platform_product_id: '',
          specimen_count: '',
          shop_creadit_product: '',
          shop_creadit_service: '',
          shop_creadit_logistics: '',
          product_format: '',
          description: '',
          remark: '',
          gift_info: '',
          copy_writer: '',
          shop_logo: '',
          shop_name: '',
          shop_tel: '',
          need_fans_number: '',
          copy_writer: '',
          post_place: '',
          post_time: '',
          begin_time: '',
          end_time: '',
          commission: '',
          sellway: '1',
          sku: [],
          title: '',
        },
        created_at: '',
        drawer: false,
        options: [{
            value: '',
            label: '全部',
          },
          {
            value: 'douyin',
            label: '抖音',
          },
          {
            value: 'kuaishou',
            label: '快手',
          },
        ],
        selcet: '',
        select2: 'douyin',
        total: 0,
        tableData: [],
        query: {
          platform_product_id: '',
          start_time: '',
          end_time: '',
          page: 1,
          list_rows: 10,
          model: '',
        },
      }
    },
    filters: {
      formatting: function(value) {
        return parseFloat(value).toFixed(2)
      },
      // 渲染产品名称
      secletproduct(value) {
        // console.log(value)
        if (value == 1) {
          let value = '食品饮料'
          return value
        } else if (value == 2) {
          let value = '生鲜水果'
          return value
        } else if (value == 3) {
          let value = '日用家居'
          return value
        } else if (value == 4) {
          let value = '酒类/茶叶'
          return value
        } else if (value == 5) {
          let value = '服饰鞋包'
          return value
        } else if (value == 6) {
          let value = '美妆个护'
          return value
        } else if (value == 7) {
          let value = '母婴童玩'
          return value
        } else if (value == 8) {
          let value = '3C数码家电'
          return value
        } else if (value == 9) {
          let value = '其他'
          return value
        }
      },
      capitalize: function(value) {
        let arr = []
        value.forEach((element) => {
          arr.push(element.current_price)
        })
        let min
        if (arr.length == 0) {
          min = '暂无'
        } else {
          min = Math.min.apply(null, arr)
        }
        return min
      },
    },
    methods: {
      exportExcel(data) { // 处理返回的文件流
      	const blob = new Blob([data]);
      	let date = new Date();
      	let today = date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date.getDate()
      	const fileName = today+'产品列表.xlsx';
      	const elink = document.createElement('a');
      	elink.download = fileName;
      	elink.style.display = 'none';
      	elink.href = URL.createObjectURL(blob);
      	document.body.appendChild(elink);
      	elink.click();
      	URL.revokeObjectURL(elink.href); // 释放URL 对象
      	document.body.removeChild(elink);
      },
      openbox(list) {
        this.listproduct = list
        this.$refs.chird.openbox()
      },
      close2() {
        this.dataJson = ''
      },
      ute() {
        	console.log(this.arr);
        Export({'idArr':this.arr}).then(response => {
				this.exportExcel(response)
				console.log(response);
			}).catch((error) => {
				console.log(error.message);
			})
      },
      // 导出
      // ute() {
      //   const column = [
      //     {
      //       title: '图片',
      //       key: 'banner',
      //       type: 'image',
      //       width: 100,
      //       height: 100,
      //     },
      //     {
      //       title: '产品分类',
      //       key: 'categories_id',
      //       type: 'text',
      //     },
      //     {
      //       title: '所属团长',
      //       key: 'channels_name',
      //       type: 'text',
      //     },

      //     {
      //       title: '活动开始时间',
      //       key: 'begin_time',
      //       type: 'text',
      //     },
      //     {
      //       title: '活动结束时间',
      //       key: 'end_time',
      //       type: 'text',
      //     },

      //     {
      //       title: '产品平台',
      //       key: 'platform',
      //       type: 'text',
      //     },
      //     {
      //       title: '产品标题',
      //       key: 'title',
      //       type: 'text',
      //     },

      //     {
      //       title: '店铺名称',
      //       key: 'shop_name',
      //       type: 'text',
      //     },
      //     {
      //       title: '产品规格',
      //       key: 'product_format',
      //       type: 'text',
      //     },
      //     {
      //       title: '商家服务分',
      //       key: 'shop_creadit_service',
      //       type: 'text',
      //     },
      //     {
      //       title: '物流体验分',
      //       key: 'shop_creadit_logistics',
      //       type: 'text',
      //     },
      //     {
      //       title: '佣金比例',
      //       key: 'commission',
      //       type: 'text',
      //     },

      //     {
      //       title: '佣金链接',
      //       key: 'url',
      //       type: 'text',
      //     },
      //     {
      //       title: '橱窗销量要求',
      //       key: 'need_fans_number',
      //       type: 'text',
      //     },
      //     // {
      //     //   title: '样品领取附加要求',
      //     //   key: 'remark',
      //     //   type: 'text',
      //     // },
      //     {
      //       title: '带货方式',
      //       key: 'sellway',
      //       type: 'text',
      //     },

      //     {
      //       title: '发货地点',
      //       key: 'post_place',
      //       type: 'text',
      //     },
      //     {
      //       title: '发货时间',
      //       key: 'post_time',
      //       type: 'text',
      //     },
      //     {
      //       title: '快递支持',
      //       key: 'express',
      //       type: 'text',
      //     },
      //     {
      //       title: '不发货地区',
      //       key: 'no_post_area',
      //       type: 'text',
      //     },
      //     {
      //       title: '直播卖点文案',
      //       key: 'copy_writer',
      //       type: 'text',
      //     },
      //   ]
      //   if (this.arr.length == 0) {
      //     this.$message.error('请先选择导出数据')
      //   } else {
      //     let obj = []
      //     this.arr.forEach((element) => {
      //       element.sku.forEach((element2) => {})
      //     })
      //     let excelName = '商品订单'
      //     table2excel(column, this.arr, excelName)
      //     this.$message.success('导出数据成功')
      //   }
      // },
      // // table 的选择导出功能
      selectAll(data) {
        // this.arr = data
        for (let s of data) {
          this.arr.push(s.id)
          // console.log("------------------",s.id);
        }

      },

      //记录所选择的ID
      checkSelect(data) {

       let arr=[];
        data.forEach(e =>{
         arr.push(e.id);
        })
        this.arr = arr
      },
      //每页条数
      sizeChangeHandle(val) {
        this.query.list_rows = val
        this.getAll()
      },
      // 复制链接
      onCopy2() {
        this.$message({
          message: `复制成功！`,
          type: 'success',
        })
        // this.snackBar.info(this.$t('prompt.copySuccess'))
      },
      onCopy() {
        this.$message({
          message: `复制成功！`,
          type: 'success',
        })
        // this.snackBar.info(this.$t('prompt.copySuccess'))
      },
      onError() {
        // this.$message.error(this.$t('prompt.copyFail'))
      },
      openxiangqing() {
        this.dialogVisible3 = true
      },
      openDataCatch() {
        this.dialogVisible4 = true
      },
      Skuupdateone(row) {
        let params = new URLSearchParams()
        params.append('id', row.id)
        params.append('price', row.price)
        params.append('current_price', row.current_price)
        Skuupdate(params)
          .then((res) => {
            if (res.code == 200) {
              this.GetOne()

              this.$message.success('修改成功')
            } else {}
          })
          .catch((err) => {
            this.$message.error('修改失败')
          })
      },

      GetOne() {
        let params = new URLSearchParams()
        params.append('id', this.upadate.id)
        Getinfo(params)
          .then((res) => {
            // console.log(res.data.sku)
            if (res.data.sku.length != 0) {
              let arr = []
              res.data.sku.forEach((element) => {
                delete element.id
                arr.push(element)
              })
              this.upadate.sku = arr
            } else {
              this.upadate.sku = arr
            }
          })
          .catch((err) => {})
      },
      SkudelOne(id) {
        let params = new URLSearchParams()
        params.append('id', id)
        Skudel(params)
          .then((res) => {
            if (res.code == 200) {
              this.GetOne()
              this.$message.success('删除成功')
            } else {}
          })
          .catch((err) => {
            this.$message.error('删除失败')
          })
      },
      close() {
        this.form.sales = ''
        this.form.no_post_area = ''
        this.form.product_format = ''
        this.form.copy_writer = ''
        this.form.service_charge = ''
        this.form.id = ''
        this.form.sku = ''
        this.form.title = ''
        this.form.categories_id = ''
        this.form.banner = ''
        this.form.img_list = ''
        this.form.platform_product_id = ''
        this.form.url = ''
        this.form.specimen_count = ''
        this.form.shop_creadit_product = ''
        this.form.shop_creadit_service = ''
        this.form.shop_creadit_logistics = ''
        this.form.product_format = ''
        this.form.shop_logo = ''
        this.form.shop_name = ''
        this.form.shop_tel = ''
        this.form.need_fans_number = ''
        this.form.copy_writer = ''
        this.form.post_place = ''
        this.form.post_time = ''
        this.form.commission = ''
        this.form.channels_name = ''
        this.form.express = ''
        this.form.description = ''
        this.form.gift_info = ''
        this.form.remark = ''
      },
      change(list) {
        // 判断list的sku 是否，不为空遍历出来
        if (list.sku.length != 0) {
          let arr = []
          list.sku.forEach((element) => {
            arr.push(element.name)
          })
          this.list_zhibo =
            '\n ' +
            '店铺：' +
            list.shop_name +
            ' \n ' +
            '产品：' +
            list.title +
            ' \n ' +
            '规格：' +
            arr.toString() +
            ' \n ' +
            '佣金：' +
            list.commission +
            '%' +
            ' \n ' +
            '链接：' +
            list.url +
            ' \n ' +
            '直播文案：' +
            list.copy_writer +
            ' \n '
        }
        this.upadate.sales = list.sales
        this.upadate.need_fans_number = list.need_fans_number
        this.upadate.product_format = list.product_format
        this.upadate.copy_writer = list.copy_writer
        this.upadate.begin_time = list.begin_time
        this.dialogVisible1 = true
        this.upadate.id = list.id
        this.upadate.sku = list.sku
        this.upadate.title = list.title
        this.upadate.categories_id = list.categories_id
        this.upadate.banner = list.banner
        var arr = list.img_list.split(',')
        this.upadate.no_post_area = list.no_post_area
        this.upadate.img_list = arr
        this.upadate.platform_product_id = list.platform_product_id
        this.upadate.url = list.url
        this.upadate.specimen_count = list.specimen_count
        this.upadate.shop_creadit_product = list.shop_creadit_product
        this.upadate.shop_creadit_service = list.shop_creadit_service
        this.upadate.shop_creadit_logistics = list.shop_creadit_logistics
        this.upadate.product_format = list.product_format
        this.upadate.shop_logo = list.shop_logo
        this.upadate.shop_name = list.shop_name
        this.upadate.shop_tel = list.shop_tel
        this.upadate.need_fans_number = list.need_fans_number
        this.upadate.copy_writer = list.copy_writer
        this.upadate.post_place = list.post_place
        this.upadate.post_time = list.post_time
        this.upadate.begin_time = list.begin_time
        this.upadate.end_time = list.end_time
        this.upadate.commission = list.commission
        this.upadate.sellway = String(list.sellway)
        this.upadate.channels_name = list.channels_name
        this.upadate.express = list.express
      },
      change2(list) {
        this.product()
        this.upadate.sales = list.sales
        this.upadate.url = list.url
        this.upadate.no_post_area = list.no_post_area
        this.upadate.service_charge = list.service_charge
        this.upadate.id = list.id
        this.dialogVisible2 = true
        this.upadate.sku = list.sku
        this.upadate.title = list.title
        this.upadate.categories_id = list.categories_id
        this.upadate.banner = list.banner
        this.upadate.img_list = list.img_list
        this.upadate.platform_product_id = list.platform_product_id
        this.upadate.specimen_count = list.specimen_count
        this.upadate.shop_creadit_product = list.shop_creadit_product
        this.upadate.shop_creadit_service = list.shop_creadit_service
        this.upadate.shop_creadit_logistics = list.shop_creadit_logistics
        this.upadate.product_format = list.product_format
        this.upadate.shop_logo = list.shop_logo
        this.upadate.shop_name = list.shop_name
        this.upadate.shop_tel = list.shop_tel
        this.upadate.need_fans_number = list.need_fans_number
        this.upadate.copy_writer = list.copy_writer
        this.upadate.post_place = list.post_place
        this.upadate.post_time = list.post_time
        this.upadate.begin_time = list.begin_time
        this.upadate.end_time = list.end_time
        this.upadate.commission = list.commission
        this.upadate.sellway = String(list.sellway)

        this.upadate.express = list.express
      },
      //添加弹框
      addbox() {
        this.dialogVisible = true
        this.product()
      },
      product() {
        let params = new URLSearchParams()
        Catetemp(params)
          .then((res) => {
            this.option = res.data
          })
          .catch((err) => {})
      },
      getAll() {
        let params = new URLSearchParams()
        params.append('model', this.query.model)
        params.append('list_rows', this.query.list_rows)
        params.append('page', this.query.page)
        params.append('start_time', this.query.start_time)
        params.append('end_time', this.query.end_time)
        Listtemp(params)
          .then((res) => {
            this.page = 1
            this.tableData = res.data
            this.total = res.total
          })
          .catch((err) => {})
      },
      //修改
      Updatetempone() {
        this.$refs.form2.validate((valid) => {
          if (valid) {
            if (this.upadate.banner == '' && this.upadate.url == '') {
              this.$message.error('请先解析商品链接')
            } else {
              let resDate = ''
              let resDate2 = ''
              let resDate3 = ''
              let d = new Date(this.upadate.begin_time)
              resDate =
                d.getFullYear() +
                '-' +
                this.p(d.getMonth() + 1) +
                '-' +
                this.p(d.getDate())
              let d2 = new Date(this.upadate.end_time)
              resDate2 =
                d2.getFullYear() +
                '-' +
                this.p(d2.getMonth() + 1) +
                '-' +
                this.p(d2.getDate())

              let d3 = new Date(this.upadate.post_time)
              resDate3 =
                d3.getFullYear() +
                '-' +
                this.p(d3.getMonth() + 1) +
                '-' +
                this.p(d3.getDate())
              let params = new FormData()
              params.append('id', this.upadate.id)
              params.append('sales', this.upadate.sales)
              params.append('platform', this.select2)
              params.append('title', this.upadate.title)
              params.append('categories_id', this.upadate.categories_id)
              params.append('banner', this.upadate.banner)
              params.append('img_list', this.upadate.img_list)
              params.append(
                'platform_product_id',
                this.upadate.platform_product_id
              )
              params.append('specimen_count', this.upadate.specimen_count)
              params.append('url', this.upadate.url)

              params.append(
                'shop_creadit_product',
                this.upadate.shop_creadit_product
              )
              params.append(
                'shop_creadit_service',
                this.upadate.shop_creadit_service
              )
              params.append(
                'shop_creadit_logistics',
                this.upadate.shop_creadit_logistics
              )
              params.append('product_format', this.upadate.product_format)
              params.append('shop_logo', this.upadate.shop_logo)
              params.append('shop_name', this.upadate.shop_name)
              params.append('shop_tel', this.upadate.shop_tel)
              params.append(
                'need_fans_number',
                Number(this.upadate.need_fans_number)
              )
              params.append('copy_writer', this.upadate.copy_writer)
              params.append('post_place', this.upadate.post_place)
              params.append('post_time', this.upadate.post_time)
              params.append('begin_time', resDate)
              params.append('end_time', resDate2)
              params.append('commission', Number(this.upadate.commission))
              params.append('service_charge', Number(this.upadate.service_charge))
              params.append('sellway', this.upadate.sellway)
              params.append('express', this.upadate.express)
              Updatetemp(params)
                .then((res) => {
                  this.$message.success('更新成功')
                  this.dialogVisible2 = false
                  this.getAll()
                })
                .catch((error) => {
                  this.dialogVisible2 = false
                  if (error.response.status == '422') {
                    this.$message.error(error.response.data.message)
                  } else {
                    this.$message.error('更新失败')
                  }
                })
            }
          }
        })
      },
      // 添加
      addtempone() {
        this.$refs.form2.validate((valid) => {
          if (valid) {
            if (this.form.banner == '') {
              this.$message.error('请先解析商品链接')
            } else {
              let resDate = ''
              let resDate2 = ''
              let resDate3 = ''
              let d = new Date(this.form.begin_time)
              resDate =
                d.getFullYear() +
                '-' +
                this.p(d.getMonth() + 1) +
                '-' +
                this.p(d.getDate())
              let d2 = new Date(this.form.end_time)
              resDate2 =
                d2.getFullYear() +
                '-' +
                this.p(d2.getMonth() + 1) +
                '-' +
                this.p(d2.getDate())

              let d3 = new Date(this.form.post_time)
              resDate3 =
                d3.getFullYear() +
                '-' +
                this.p(d3.getMonth() + 1) +
                '-' +
                this.p(d3.getDate())
              let params = new FormData()
              params.append('sales', this.form.sales)
              params.append('sku', JSON.stringify(this.form.sku))
              params.append('platform', this.select2)
              params.append('title', this.form.title)
              params.append('categories_id', this.form.categories_id)
              params.append('banner', this.form.banner)
              params.append('img_list', this.form.img_list)
              params.append('platform_product_id', this.form.platform_product_id)
              params.append('specimen_count', this.form.specimen_count)
              params.append('url', this.form.url)
              params.append(
                'shop_creadit_product',

                this.form.shop_creadit_product
              )
              params.append(
                'shop_creadit_service',
                this.form.shop_creadit_service
              )
              params.append(
                'shop_creadit_logistics',
                this.form.shop_creadit_logistics
              )
              params.append(
                'product_format',
                JSON.stringify(this.form.product_format)
              )
              params.append('no_post_area', this.form.no_post_area)
              params.append('shop_logo', this.form.shop_logo)
              params.append('shop_name', this.form.shop_name)
              params.append('shop_tel', this.form.shop_tel)
              params.append('need_fans_number', this.form.need_fans_number)
              params.append('copy_writer', this.form.copy_writer)
              params.append('post_place', this.form.post_place)
              params.append('post_time', this.form.post_time)
              params.append('begin_time', resDate)
              params.append('end_time', resDate2)
              params.append('commission', this.form.commission)
              params.append('service_charge', this.form.service_charge)
              params.append('sellway', this.form.sellway)
              params.append('express', this.form.express)
              this.getAll()
              Addtemp(params)
                .then((res) => {
                  this.getAll()
                  this.$message.success('添加成功')
                  this.dialogVisible = false
                })
                .catch((error) => {
                  this.dialogVisible = false
                  if (error.response.status == '422') {
                    this.$message.error(error.response.data.message)
                  } else {
                    this.$message.error('添加失败')
                  }
                })
            }
          }
        })
      },
      analysis() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            let signIndex = this.form.url.search('id=', 2)
            let sign = this.form.url.substring(signIndex)
            window.open(
              'https://ec.snssdk.com/product/fxgajaxstaticitem?b_type_new=0&device_id=0&is_outside=1&preview=0&is_native_h5=1&' +
              sign,
              '_blank'
            )
          }
        })
      },
      handleCurrentChange(e) {
        this.query.page = e
        this.getAll()
      },
      del(id) {
        let params = new URLSearchParams()
        params.append('id', id)
        Deltep(params)
          .then((res) => {
            if (res.code == 200) {
              this.$message.success('删除成功')
              this.getAll()
            } else {}
          })
          .catch((err) => {
            this.$message.error('删除失败')
          })
      },
      p(s) {
        return s < 10 ? '0' + s : s
      },
      selectChanged2() {
        this.created_at = ''
        this.query.platform_product_id = ''
        let params = new URLSearchParams()
        params.append('platform_product_id', '')
        params.append('model', '')
        params.append('list_rows', 10)
        params.append('page', 1)
        params.append('start_time', '')
        params.append('end_time', '')
        Listtemp(params)
          .then((res) => {
            this.tableData = res.data
            this.total = res.total
            this.$message.success('重置成功')
          })
          .catch((err) => {})
      },
      selectChanged() {
        let resDate = ''
        let resDate2 = ''
        if (this.created_at == '') {
          resDate == ''
          resDate2 == ''
        } else {
          let d = new Date(this.created_at[0])
          resDate =
            d.getFullYear() +
            '-' +
            this.p(d.getMonth() + 1) +
            '-' +
            this.p(d.getDate())
          let d2 = new Date(this.created_at[1])
          resDate2 =
            d2.getFullYear() +
            '-' +
            this.p(d2.getMonth() + 1) +
            '-' +
            this.p(d2.getDate())
        }
        let params = new URLSearchParams()
        params.append('keyword', this.query.keyword)
        params.append('model', this.query.model)
        params.append('list_rows', this.query.list_rows)
        params.append('page', this.query.page)
        params.append('start_time', this.query.start_time)
        params.append('end_time', this.query.end_time)
        Listtemp(params)
          .then((res) => {
            this.query.keyword = ''
            this.query.model = ''
            this.query.created_at = ''
            this.tableData = res.data
            this.total = res.total
            this.$message.success('搜索成功')
          })
          .catch((err) => {})
      },
      formatter(row, column) {
        return row.address
      },
      getJsonString() {
        let obj = JSON.parse(this.dataJson).data
        //console.log(obj);
        this.form.sales = obj.sell_num
        this.form.shop_name = obj.shop_name
        this.form.description = obj.description
        this.form.gift_info = obj.gift_info
        this.form.remark = obj.remark
        this.form.shop_logo = obj.shop_logo
        this.form.need_fans_number = obj.need_fans_number
        this.form.categories_id = obj.categories_id
        this.form.banner = obj.img
        this.form.description = obj.description
        this.form.title = obj.name
        this.form.img_list = obj.img_list
        // console.log('-----------------------------------------------',obj.freight)
        if (obj.freight) {
          this.form.no_post_area = obj.freight.columns[0].province_name
          this.form.post_place = obj.freight.product_province_name
        } else {
          this.form.no_post_area = ''
          this.form.post_place = ''
        }
        this.form.platform_product_id = obj.product_id
        this.form.post_time = obj.detail_delay_desc
        this.form.product_format = obj.product_format
      //  console.log('---------------------------------', this.form.product_format);
        this.form.shop_creadit_logistics = obj.credit_score.logistics
        this.form.shop_creadit_product = obj.credit_score.product
        this.form.shop_creadit_service = obj.credit_score.shop
        if (obj.spec_info.length === 1) {
          if (obj.spec_info[0].list.length != 0) {
            let arr = []
            obj.spec_info[0].list.forEach((element) => {
              ;
              (element.price = 0), (element.current_price = 0)
              delete element.id
              arr.push(element)
            })
            this.form.sku = arr
          } else {
            this.form.sku = arr
          }
        } else {
          let arr = []
          for (var i = 0; i < obj.spec_info[0].list.length; i++) {
            for (var k = 0; k < obj.spec_info[1].list.length; k++) {
              let temp = {}
              temp.price = 0
              temp.current_price = 0
              temp.name = obj.spec_info[0].list[i].name + obj.spec_info[1].list[k].name
              arr.push(temp)
            }
          }
          this.form.sku = arr
        }

        this.form.shop_tel = obj.shop_tel
        this.dialogVisible4 = false
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/view/product/product.vue